import { get, omit } from 'lodash';
import update from 'immutability-helper';

import Constants from '../constants';

const initialState = {
  responseUuid: null,
  answerList: {},
  answerPendingQueue: {},
  awaitForAnswerNextButtonId: null,
};

export const getAnswerPendingQueue = state => state.answerPendingQueue;
export const getSurveyResponseUuid = state => state.responseUuid;
export const getAwaitForAnswerNextButtonId = state =>
  state.awaitForAnswerNextButtonId;
export const isAnyAnswerPending = state =>
  !!Object.keys(getAnswerPendingQueue(state)).length;
export const getAnswers = state => state.answerList;
export const getAnswerById = (state, id) => get(getAnswers(state), id, null);

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.SET_RESPONSE_UUID: {
      return update(state, {
        responseUuid: { $set: action.payload },
      });
    }

    case Constants.SET_AWAIT_FOR_ANSWER_NEXT_BUTTON_ID: {
      return update(state, {
        awaitForAnswerNextButtonId: { $set: action.payload },
      });
    }

    case Constants.CLEAR_AWAIT_NEXT_BUTTON_ID: {
      return update(state, {
        awaitForAnswerNextButtonId: { $set: null },
      });
    }

    case Constants.ADD_BLOCK_TO_ANSWER_PENDING_QUEUE: {
      const questionId = action.payload;
      return update(state, {
        answerPendingQueue: { $merge: { [questionId]: true } },
      });
    }

    case Constants.REMOVE_BLOCK_FROM_ANSWER_PENDING_QUEUE: {
      return update(state, {
        answerPendingQueue: {
          $set: omit(getAnswerPendingQueue(state), action.payload),
        },
      });
    }

    case Constants.SET_ANSWER_LIST: {
      return update(state, {
        answerList: { $set: action.payload },
      });
    }

    case Constants.SET_ANSWER: {
      const { id, answer } = action.payload;
      return update(state, {
        answerList: {
          [id]: { $set: answer },
        },
      });
    }

    default: {
      return state;
    }
  }
}
